const KeywordSearchesLegal = {
	'user_id': '',
	'type': 'keyword',
	'keyword': ['important'],
	'items': [
		{
			'available_keywords': ['important'],
			'file_name': 'LegalAidBC-Everyday-legal-needs-survey-2020',
			'highlight': {
				'text': [
					'Specifically, three-quarters felt it was <b class="search-result">important</b> to take care of their legal problem when it was at...its worst, including 29% reporting it was extremely <b class="search-result">important</b> (down from 80% and 38% in 2018, respectively...Perceived Importance of Resolving Legal Problem(s) Experienced Extremely <b class="search-result">important</b> 29% Low-income British...38% Columbians who are most 80% 74% Very <b class="search-result">important</b> likely to feel it was extremely felt it was felt...it was <b class="search-result">important</b> to take care of their Somewhat <b class="search-result">important important</b> to <b class="search-result">important</b> to legal problems include...'
				],
				'length': '5'
			},
			'page': ['44']
		},
		{
			'available_keywords': ['important'],
			'file_name': 'a-vision-for-publicly-funded-legal-aid-in-british-columbia',
			'highlight': {
				'text': [
					'This is an <b class="search-result">important</b> aspect of the work of the Task Force, because the Law Society is simply one of a...Continued participation in the BC Access to Justice Committee is highly <b class="search-result">important</b>, as it is acting largely...Participation in the Justice Summits is also <b class="search-result">important</b> as it also coordinates discussion on issues....in the debate over legal aid for the last number of years and that as a consequence the voice of an <b class="search-result">important</b>...It considers that a recommendation to the Benchers to change that reality is <b class="search-result">important</b>....'
				],
				'length': '5'
			},
			'page': '16'
		},
			{
			'available_keywords': ['important'],
			'file_name': 'LegalAidBC_service-plan',
			'highlight': {
				'text': [
					'Linking Performance Measures to Objectives: 1.3a Increased engagement is an <b class="search-result">important</b> step toward advancing...'
				],
				'length': '5'
			},
			'page': '10'
		}
	],
	'id': '',
	'date': ''
}
export default KeywordSearchesLegal;